// Lazy load function
const lazyLoad = (file) => () =>
  import(
    /* webpackChunkName: "[request]" */ `@/views/inventory/grid-reports/${file}.vue`
  );

export default [
  {
    path: "/bin-list",
    name: "bin-list",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "BinList",
    },
    components: {
      content: lazyLoad("bin-list"),
    },
  },
  {
    path: "/report-bulk-stock",
    name: "report-bulk-stock",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoReportGridBulkStock",
    },
    components: {
      content: lazyLoad("bulk-stock-allocation"),
    },
  },
  {
    path: "/intake-bin-movement",
    name: "intake-bin-movement",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoReportGridBinMovement",
    },
    components: {
      content: lazyLoad("bin-movement"),
    },
  },
  {
    path: "/intake-bin-Location",
    name: "intake-bin-Location",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoReportGridBinLocation",
    },
    components: {
      content: lazyLoad("bin-location"),
    },
  },

  {
    path: "/report-bulk-stock-hanwood",
    name: "report-bulk-stock-hanwood",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "AlmondcoReportGridBulkStockHanwood",
    },
    components: {
      content: lazyLoad("report-bulk-stock-hanwood"),
    },
  },
];
